<div class="col-sm-12">
    <p>
        Cosa è RSS?
        <br />
        RSS è un sistema che puoi usare per rimanere aggiornato su articoli che
        ti interessano, eventi o simili senza bisogno di iscriversi a newsletter
        che ti intasano la mail o bombardamenti di notifiche.
    </p>
    <p>
        Molto probabilmente anche i tuoi giornali preferiti hanno un feed RSS
        attivo, oltre a questo sito qua
    </p>
    <ul>
        <li>
            <p>
                Ricevi le notifiche e/o consulta gli eventi dall'app Feeder.
                <br />
                Se c'hai l'Phone te ne cerchi una, hai voluto la bicicletta e
                ora pedali 😁
            </p>
            <a
                href="https://f-droid.org/repository/browse/?fdid=com.nononsenseapps.feeder"
                class="button">Scarica da F-Droid</a>
            <a
                href="https://play.google.com/store/apps/details?id=com.nononsenseapps.feeder.play"
                class="button">Scarica da Play Store</a>
        </li>
        <li>
            Poi nell'app da "Aggiungi Feed", incolla il link qui sotto e premi
            invio sulla tastiera del telefono<br />
            <pre>https://piazzacolombo.approu.it/rss</pre>
            Allo stesso modo potrai aggiungere anche altri siti di tuo interesse
        </li>

        <li>
            Dopo averlo aggiunto, in alto a destra c'è una campanella,
            assicurati che le notifiche siano attivate.
            <br />Non ho ancora provato a sufficienza le notifiche, non so se
            arrivino sempre o ci possano essere problemi, fatemi sapere come
            vanno
        </li>
    </ul>
</div>
